module.exports = __webpack_public_path__ + "static/media/BusinessRole.960a01ea.svg";